import { makeStyles, createStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      marginBottom: theme.spacing(1),
    },
    root: {
      width: '100%',
      maxWidth: '100%',
      position: 'relative',
      margin: theme.spacing(1),
      overflowY: 'auto',
      paddingBottom: theme.spacing(1),
    },
    rowsContainer: {
      maxWidth: '100%',
    },
    loading: {
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3),

      '& > * + *': {
        marginTop: '0 !important',
      },
    },
    skeleton: {
      width: '100%',
      height: 60,
      transform: 'scale(1, 0.82)',
    },
  }),
);
